module.exports = __webpack_public_path__ + "static/media/chat_bubble.842204cd.svg";